import { Input } from 'antd';

const { TextArea } = Input;

export const useLastStepFields = () => {
  const lastStepFields = [
    {
      name: ['comment_or_suggestion'],
      label: 'comment_or_suggestion',
      input: <TextArea />
    }
  ];

  return { lastStepFields };
};
